export const GET_LISTS = 'GET_LISTS';
export const SET_LISTS = 'SET_LISTS';
export const UPDATE_LIST = 'UPDATE_LIST';
